import { Component, OnInit } from '@angular/core';
import { HomePageService } from '../homepage.service';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.css']
})
export class TermsAndConditionsComponent implements OnInit {
  termsAndConditions: string;

  constructor(private homePageService: HomePageService) { }

  ngOnInit(): void {
    this.getTermsAndPrivacyData();
  }

  getTermsAndPrivacyData() {
    this.homePageService.termConditionAndPrivacyPolicy().subscribe((data: any) => {
      this.termsAndConditions = data.termAndPrivacyData.termCondition;
      // this.privacyPolicy = data.termAndPrivacyData.privacyPolicy;
      // this.cancellationPolicy = data.termAndPrivacyData.cancellationPolicy;
    });
  }

}
